(() => {
  const grid = document.getElementById('all-posts-grid');
  if (!grid) return;

  const perPage = parseInt(grid.getAttribute('data-per-page') || '12', 10);
  let items = Array.from(grid.querySelectorAll('.post-item'));

  // OPTIONAL: sort by latest using data-published
  items.sort((a, b) => (b.dataset.published || '').localeCompare(a.dataset.published || ''));
  items.forEach(el => grid.appendChild(el));

  const prevBtn = document.querySelector('[data-posts-prev]');
  const nextBtn = document.querySelector('[data-posts-next]');
  const pagesEl = document.querySelector('[data-posts-pages]');

  const totalPages = Math.max(1, Math.ceil(items.length / perPage));

  const toggleDisabled = (btn, isDisabled) => {
    if (!btn) return;
    btn.disabled = isDisabled;
    btn.classList.toggle('btn_disabled', isDisabled);
  };

  const getPageFromUrl = () => {
    const url = new URL(window.location.href);
    const p = parseInt(url.searchParams.get('page') || '1', 10);
    return Math.min(Math.max(p, 1), totalPages);
  };

  const setPageToUrl = (p) => {
    const url = new URL(window.location.href);
    url.searchParams.set('page', String(p));
    history.pushState({}, '', url.toString());
  };

  // windowed pagination: max 7 number + ellipsis
  const buildPages = (activePage) => {
    if (!pagesEl) return;
    pagesEl.innerHTML = '';

    const maxButtons = 7;

    const mkBtn = (label, page, isActive = false, isDots = false) => {
      const li = document.createElement('li');
      li.className = 'mx-2';

      const el = document.createElement('button');
      el.type = 'button';
      el.textContent = label;

      el.className = isActive
        ? 'pagination__item border-b-1 border-b-scheme-text inline-block lg:px-1 lg:py-1 active'
        : 'pagination__item inline-block lg:px-1 lg:py-1';

      if (isDots) {
        toggleDisabled(el, true); // disable + btn_disabled
      } else {
        el.addEventListener('click', () => go(page));
      }

      li.appendChild(el);
      pagesEl.appendChild(li);
    };

    if (totalPages <= maxButtons) {
      for (let p = 1; p <= totalPages; p++) mkBtn(String(p), p, p === activePage);
      return;
    }

    // Always show: 1 ... window ... ... last
    const windowSize = 3; // around active
    let start = Math.max(2, activePage - windowSize);
    let end = Math.min(totalPages - 1, activePage + windowSize);

    // adjust to keep consistent count
    const desiredWindow = maxButtons - 2; // excluding first & last
    while ((end - start + 1) < desiredWindow) {
      if (start > 2) start--;
      else if (end < totalPages - 1) end++;
      else break;
    }

    mkBtn('1', 1, activePage === 1);

    if (start > 2) mkBtn('…', null, false, true);

    for (let p = start; p <= end; p++) mkBtn(String(p), p, p === activePage);

    if (end < totalPages - 1) mkBtn('…', null, false, true);

    mkBtn(String(totalPages), totalPages, activePage === totalPages);
  };

  const render = (page) => {
    const start = (page - 1) * perPage;
    const end = start + perPage;

    items.forEach((el, idx) => {
      el.style.display = (idx >= start && idx < end) ? '' : 'none';
    });

    toggleDisabled(prevBtn, page <= 1);
    toggleDisabled(nextBtn, page >= totalPages);

    buildPages(page);

    // scroll to top
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
  };

  const go = (p) => {
    const page = Math.min(Math.max(p, 1), totalPages);
    setPageToUrl(page);
    render(page);
  };

  // init
  render(getPageFromUrl());

  if (prevBtn) prevBtn.addEventListener('click', () => go(getPageFromUrl() - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => go(getPageFromUrl() + 1));
  window.addEventListener('popstate', () => render(getPageFromUrl()));
})();